import React from 'react';
import { Box, Container, Typography, Button, AppBar, Toolbar } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import heroImage from '../assets/hero.jpg';
import Logo from '../components/Logo';

const LandingPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#0a0a1a' }}>
      <AppBar position="static" elevation={0} sx={{ bgcolor: 'transparent', backdropFilter: 'blur(10px)' }}>
        <Toolbar>
          <Logo size={40} />
          <Typography variant="h6" sx={{ ml: 2, fontWeight: 700, color: 'white', flexGrow: 1 }}>
            Sakura ShiftSync
          </Typography>
          <Button color="inherit" onClick={() => navigate('/login')}>
            Sign In
          </Button>
        </Toolbar>
      </AppBar>

      <Container maxWidth="sm" sx={{ py: 8, textAlign: 'center' }}>
        <Typography
          variant="h3"
          sx={{
            fontWeight: 800,
            color: 'white',
            mb: 2,
            fontSize: { xs: '2rem', sm: '2.5rem' },
          }}
        >
          Your Shifts,{' '}
          <Box component="span" sx={{ color: '#E91E63' }}>
            Simplified
          </Box>
        </Typography>
        
        <Typography
          variant="h6"
          sx={{
            color: 'rgba(255, 255, 255, 0.7)',
            mb: 4,
          }}
        >
          Manage your schedule, request time off, and swap shifts - all from your mobile device.
        </Typography>

        <Box
          component="img"
          src={heroImage}
          alt="Sakura ShiftSync App"
          sx={{
            width: '100%',
            borderRadius: 4,
            boxShadow: '0 20px 60px rgba(233, 30, 99, 0.3)',
            mb: 4,
          }}
        />

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Button
            variant="contained"
            size="large"
            onClick={() => navigate('/login')}
            sx={{
              py: 1.5,
              fontSize: '1.1rem',
              bgcolor: '#E91E63',
              '&:hover': { bgcolor: '#C2185B' },
            }}
          >
            Get Started
          </Button>
          <Button
            variant="outlined"
            size="large"
            onClick={() => navigate('/demo')}
            sx={{
              py: 1.5,
              fontSize: '1.1rem',
              color: 'white',
              borderColor: 'rgba(255, 255, 255, 0.5)',
              '&:hover': { borderColor: 'white' },
            }}
          >
            Learn More
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default LandingPage;
